<section class="spread-workspace" [class.is-busy]="saving">
  @if(loading){<p role="status">Loading spread options…</p>}
  @if(loadError){<div role="alert">{{loadError}} <button class="btn-bg-blue" type="button" mat-button (click)="ngOnInit()">Retry</button></div>}
  @if(saveOutcomeUnknown){<p role="alert">The save result could not be confirmed. Return to the list and check the spread before trying again.</p>}
  <nav class="spread-progress" aria-label="Spread creation progress">
    <button type="button" [class.current]="EditForm && !allocationOpen" [attr.aria-current]="EditForm && !allocationOpen ? 'step' : null" [disabled]="saving || building" (click)="goToDetails()">1 � Order details</button>
    <button type="button" [class.current]="EditForm && allocationOpen" [attr.aria-current]="EditForm && allocationOpen ? 'step' : null" [disabled]="saving || building || !allocationVisited || !MultiOrderForm.valid" (click)="goToAllocation(!!MultiOrderForm.valid)">2 � Month & warehouse allocation</button>
    <span [class.current]="!EditForm" [attr.aria-current]="!EditForm ? 'step' : null">3 � Review & save</span>
  </nav>
  <div [hidden]="loading || !!loadError">
  <!-- ===== Date / Container header ===== -->
  <form #DatePickForm="ngForm" class="spread-header">
    <h1 style="margin:0">Purchase order spread</h1>

    <div class="spread-dates" [hidden]="!EditForm || allocationOpen">
      @if(!TotalContainers || !BagsPerContainer){<p class="spread-intro">Choose the shipping period, total containers and bags per container.</p>}
      <div style="display:flex; gap:20px; align-items:center; justify-content:center;">
        <rms-select (ngModelChange)="onStartDateChange($event)"
                    name="shipStart" label="Start Ship"
                    [required]="true" [ngModel]="MultiOrder.StartShip"
                    [options]="monthYearOptions" labelKey="label" valueKey="value">
        </rms-select>

        <rms-select (ngModelChange)="onEndDateChange($event)"
                    name="shipEnd" label="End Ship"
                    [required]="true" [ngModel]="MultiOrder.EndShip"
                    [options]="filteredEndMonthOptions" labelKey="label" valueKey="value"
                    [disabled]="!MultiOrder.StartShip">
        </rms-select>

        <div>
          <rms-number [disabled]="!MultiOrder.StartShip || !MultiOrder.EndShip"
                      name="containers" [ngModel]="TotalContainers" (ngModelChange)="onContainerChange($event)"
                      label="Total Containers" [required]="true"></rms-number>
        </div>

        <div>
          <rms-number [disabled]="!MultiOrder.StartShip || !MultiOrder.EndShip"
                      name="weightpercontainer" [ngModel]="BagsPerContainer" (ngModelChange)="onBagsPerContainerChange($event)"
                      label="Bags Per Container" [required]="true"></rms-number>
        </div>
      </div>
    </div>
  </form>

  <!-- ===== Shared Order Details ===== -->
  <form #MultiOrderForm="ngForm" style="display:flex; flex-direction:column; width:99%"
        [hidden]="!TotalContainers || !BagsPerContainer || !EditForm || allocationOpen">
    <div style="display:flex; gap:40px">
      <div style="display:flex; flex-direction:column; width:100%">
        <fieldset class="rms-fieldset" style="display:flex; flex-direction:column">
          <legend>Purchase Order Information</legend>

          <div style="display:flex; justify-content:space-between; width:99%">
            <rms-search-select [disabled]="!EditForm" (ngModelChange)="onAnyFieldChanged()" style="width:48%"
                               name="supplier" label="Supplier"
                               [options]="InventoryData.Suppliers" labelKey="SupplierName" valueKey="SupplierID"
                               [(ngModel)]="MultiOrder.SupplierID">
            </rms-search-select>

            <rms-search-select [disabled]="!EditForm" (ngModelChange)="onAnyFieldChanged()" style="width:48%"
                               name="sku" label="SKU"
                               [options]="InventoryData.Products" labelKey="InventoryTypeName" valueKey="InventoryTypeID"
                               [(ngModel)]="MultiOrder.InventoryTypeID">
            </rms-search-select>
          </div>

          <div class="purchase-order-information-fieldset" [class.show]="MultiOrder.SupplierID && MultiOrder.InventoryTypeID">
            <rms-date (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="purchaseDate"
                      [required]="true" label="Purchase Date" [(ngModel)]="MultiOrder.PurchaseDate"></rms-date>

            <rms-select (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="buyer"
                        [required]="true" label="Royal NY Buyer"
                        [options]="InventoryData.Traders" labelKey="DisplayName" valueKey="GraphUserID"
                        [(ngModel)]="MultiOrder.TraderGUID">
            </rms-select>

            <rms-select (ngModelChange)="onShippingTermChange($event)" [disabled]="!EditForm" name="shipTerms"
                        [required]="true" label="Shipment Terms"
                        [options]="InventoryData.ShipmentTerms" labelKey="ShipmentTermName" valueKey="ShipmentTermId"
                        [(ngModel)]="MultiOrder.ShippingTerm">
            </rms-select>

            <rms-select (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="sampleTerms"
                        [required]="true" label="SAS Terms"
                        [options]="InventoryData.SampleApprovalTerms" labelKey="SampleApprovalTerm" valueKey="SampleApprovalTermID"
                        [(ngModel)]="MultiOrder.SASTermID">
            </rms-select>

            <rms-select (ngModelChange)="onShipmentTypeChange($event)" [disabled]="!EditForm" name="shipTypes"
                        [required]="true" label="Shipment Type"
                        [options]="InventoryData.ShipmentTypes" labelKey="ShipmentTypeName" valueKey="ShipmentTypeId"
                        [(ngModel)]="MultiOrder.ShipmentTypeID">
            </rms-select>

            <rms-select (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="paymentTerms"
                        [required]="true" label="Payment Terms"
                        [options]="InventoryData.PaymentTerms" labelKey="PaymentTermName" valueKey="PaymentTermId"
                        [(ngModel)]="MultiOrder.PaymentTermsID">
            </rms-select>

            <rms-select (ngModelChange)="onBuyingTermChange()" [disabled]="!EditForm" name="FixedOrDiff"
                        [required]="true" label="Fixed Or Differential"
                        [options]="[{value:1,label:'Fixed'},{value:2,label:'Differential'}]" labelKey="label" valueKey="value"
                        [(ngModel)]="MultiOrder.BuyingTermID">
            </rms-select>

            <rms-select (ngModelChange)="updatePerPoundCost(); onAnyFieldChanged()" [disabled]="!EditForm" name="Pricedes"
                        [required]="true" label="Price Descriptor"
                        [options]="filteredPricings" labelKey="PriceDescriptorName" valueKey="PriceDescriptorID"
                        [(ngModel)]="MultiOrder.PriceDescriptorID">
            </rms-select>

            <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="salesPerson"
                       [required]="true" [(ngModel)]="MultiOrder.SupplierAgent" label="Sales Person"></rms-input>

            <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="intermediary"
                       [(ngModel)]="MultiOrder.Intermediary" label="Intermediary"></rms-input>

            <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="intermediarynumber"
                       [(ngModel)]="MultiOrder.IntermediaryNumber" label="Intermediary Number"></rms-input>

            <rms-select (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="weightTypes"
                        [required]="true" label="Weight Terms"
                        [options]="InventoryData.WeightTypes" labelKey="WeightTypeName" valueKey="WeightTypeId"
                        [(ngModel)]="MultiOrder.WeightTypeID">
            </rms-select>

            <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="bagWeight"
                       [required]="true" type="decimal" label="Bag Weight"
                       [(ngModel)]="MultiOrder.NetWeight"></rms-input>

            <rms-radio [required]="true" [disabled]="!EditForm" name="fixedby"
                       [(ngModel)]="MultiOrder.PriceFixedBy"
                       [options]="[{value: 1, label: 'Royal NY'}, {value: 2, label: 'Supplier'}]"
                       label="Price To Be Fixed By" (change)="SetPriceToBeFixedBy()"
                       [flexRow]="true">
            </rms-radio>
            <div style="flex-basis:100%; height:0"></div>

            <!-- Commissions -->
            <fieldset class="rms-fieldset form-field" style="gap:30px; display:flex; width:45%">
              <legend style="font-size:18px">Commissions</legend>
              <div style="width: 99%; gap: 30px; display: flex;">
                <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="SupplierCom"
                           type="currency" [(ngModel)]="MultiOrder.SupplierCommission" label="Supplier" decimalFormat="1.2-4"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="RainforestCom"
                           type="currency" [(ngModel)]="MultiOrder.RainforestCommission" label="Rainforest" decimalFormat="1.2-4"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="OrganicCom"
                           type="currency" [(ngModel)]="MultiOrder.OrganicCommission" label="Organic" decimalFormat="1.2-4"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="Intercom"
                           type="currency" [(ngModel)]="MultiOrder.IntermediaryCommission" label="Intermediary" decimalFormat="1.2-4"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" [disabled]="!EditForm" name="othercom"
                           type="currency" [(ngModel)]="MultiOrder.CommissionOtherLevel" label="Miscellaneous" decimalFormat="1.2-4"></rms-input>
              </div>
            </fieldset>

            @if(MultiOrder.FairTrade){
            <fieldset class="rms-fieldset form-field" style="gap:30px; display:flex; width:45%">
              <legend style="font-size:18px">Fair Trade</legend>
              <div style="width:99%; display:flex; gap:30px">
                <rms-input (ngModelChange)="onAnyFieldChanged()" decimalFormat="1.2-4" [disabled]="!EditForm"
                           name="FairTradeMinimum" type="currency" [(ngModel)]="MultiOrder.FairTradeMinimum" label="Fair Trade Minimum"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" decimalFormat="1.2-4" [disabled]="!EditForm"
                           name="FairTradePremium" type="currency" [(ngModel)]="MultiOrder.FairTradePremium" label="Fair Trade Premium"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" decimalFormat="1.2-4" [disabled]="!EditForm"
                           name="org" type="currency" [(ngModel)]="MultiOrder.OrganicPremium" label="Organic Premium"></rms-input>
                <rms-input (ngModelChange)="onAnyFieldChanged()" decimalFormat="1.2-4" [disabled]="!EditForm"
                           name="cprem" type="currency" [(ngModel)]="MultiOrder.CountryPremium" label="Country Premium"></rms-input>
              </div>
            </fieldset>
            }
            <fieldset class="rms-fieldset" style="width:45%">
              <legend style="font-size:16px;">Futures Month for Forward Spread Price Basis</legend>
              <div style="display:flex; gap:18px; width:98%">
                @for(fm of MultiOrder.PriceBaseByFuture; track fm.FutureCompositeID){
                <div>
                  <rms-input style="flex-basis:20%" [disabled]="!EditForm"
                             [name]="'pb-fc-' + fm.FutureCompositeID"
                             type="currency"
                             decimalFormat="1.2-4"
                             [label]="fm.FutureCompositeName"
                             [(ngModel)]="fm.PriceBase"
                             (ngModelChange)="onAnyFieldChanged()"
                             [required]="true">
                  </rms-input>
                </div>
                }
              </div>
            </fieldset>
          </div>
        </fieldset>
      </div>
    </div>
  </form>

  @if(EditForm && !allocationOpen && TotalContainers && BagsPerContainer){<div class="spread-actions"><button type="button" mat-flat-button class="btn-bg-blue" [disabled]="!MultiOrderForm.valid" (click)="goToAllocation(!!MultiOrderForm.valid)">Continue to allocation</button><p *ngIf="!MultiOrderForm.valid">Complete the required order details to continue.</p></div>}
  <!-- ===== Build & Preview ===== -->
  @if(!EditForm){
  <form #BuildOrderForm="ngForm">
    <fieldset class="rms-fieldset" style="display:flex; flex-direction:column">
      <legend>Purchase Orders</legend>
      <div style="display:flex; justify-content:space-between">
        <div>
          <h3 class="review-summary">
            {{PurchaseOrders.length}} purchase orders ready. Review the quantities, destinations and pricing before saving.
          </h3>
        </div>
        <div style="display:flex; justify-content:right">
          <button type="button" mat-button class="btn-bg-slate" (click)="goToAllocation(!!MultiOrderForm.valid)">Back to allocation</button>
          <button type="button" mat-button class="btn-bg-green" (click)="savePurchaseOrders()" [disabled]="saving || saveOutcomeUnknown || BuildOrderForm.invalid">{{saving ? 'Saving spread…' : selectedPurchaseOrders.length ? 'Update purchase orders' : 'Create purchase orders'}}</button>
        </div>
      </div>

      <!-- ✅ New expandable table (parents with decaf children) -->
      <div style="height:40vh" [ngClass]="{'fade-in' : !EditForm, 'fade-out': EditForm}">
        <rms-table [data]="InventoryForTable"
                    [icons]="InventoryIcons"
                    [columns]="PurchaseOrderColumns"
                    [IncludePaginator]="false"
                    [IncludeSearch]="false"
                    [startSort]="'shipDate'"
                    [startSortDirection]="'asc'"
                    ExpandedText="Decaf"
                    [expandedTemplate]="expandedTemplate">
        </rms-table>
      </div>

      <!-- Child row template -->
      <ng-template #expandedTemplate let-row>
        @if(row.ChildInventory && row.ChildInventory.length > 0){
        <div style="display:flex; justify-content:center; width:98%">
          <fieldset class="rms-fieldset" style="width: 90%; display:flex; flex-direction:column">
            <legend style="font-weight:bolder; font-size:24px">Decaf Child{{row.InventoryID ? ' Of Parent Reff #:' + row.InventoryID : '' }}</legend>
            <div style="display:flex;">
              @if(row.ChildInventory[0].DecaffeinatorID == 1992){
              <rms-select [name]="row._tempKey + '- Desc'" style="flex-basis:25%" label="Tolling Contract" [options]="InventoryData.TollingContracts" labelKey="Label" valueKey="TollingContractID" [(ngModel)]="row.ChildInventory[0].DecafTollingContractID"></rms-select>
              }
              @else{
              <rms-input [name]="row._tempKey + '- Sea'" style="flex-basis:25%" type="text" label="Tolling Contract" [(ngModel)]="row.ChildInventory[0].DecafTollingContractID"></rms-input>
              }
            </div>
            <rms-table [data]="row.ChildInventory"
                        [columns]="ChildInventoryColumns"
                        [IncludePaginator]="false"
                        [IncludeSearch]="false"
                        [IncludeSort]="false"
                        [MultiExpand]="true"
                        headerBackground="rgba(134, 203, 236, .75)">
            </rms-table>
          </fieldset>
        </div>
        } @else {
        <div style="padding:6px 2px; color: var(--muted, #888)">No Children</div>
        }
      </ng-template>
    </fieldset>
  </form>
  }

  <div [hidden]="!allocationOpen || !EditForm">
    <fieldset class="rms-fieldset allocation-panel">
      <legend>Month & warehouse allocation</legend>

      <button class="btn-bg-slate" type="button" mat-button [disabled]="saving || building" (click)="goToDetails()">Back to order details</button>
      @if(MultiOrderForm.valid){
      <div style="display:flex; justify-content:space-between; align-items:center;">
        <div [ngStyle]="{'color' : WarehouseFormError() ? 'red' : 'green'}" style="width:25%">
          {{RemainingContainers()}}
        </div>
        <div style="display:flex; width:99%; justify-content:right; align-items:center">
          <div style="color:red">{{WarehouseFormError()}}</div>
          <button type="button" [disabled]="building || saving || !!WarehouseFormError() || !SpreadForm.valid || !MultiOrderForm.valid"
                  mat-button class="btn-bg-blue" (click)="onBuildPurchaseOrders()">
            {{building ? 'Building…' : 'Review spread'}}
          </button>
        </div>
      </div>
      }

      <form #SpreadForm="ngForm" class="allocation-grid">
        @for(w of Warehouses; track w.id){
        <div style="display:flex; gap:20px">
          <rms-search-select style="flex-basis:25%" [required]="true"
                             [options]="filteredDestinationWarehousesFor($index)"
                             labelKey="LocationName" valueKey="LocationID"
                             [name]="'Locations - ' + $index" label="{{w.Decaf ? 'Toll Decaf Location' : 'Destination Warehouse'}}"
                             [(ngModel)]="w.FinalDestinationWarehouseID" (ngModelChange)="onChangeWarehouse(w, $event)">
          </rms-search-select>

          <!-- Price / Diff per warehouse (drives per-pound conversion) -->
          <rms-input *ngIf="MultiOrder.BuyingTermID == 1"
                     [suffix]="w.PerPoundCost + '/lb'"
                     (ngModelChange)="updatePerPoundCost(w)"
                     style="flex-basis:15%" [required]="true"
                     [name]="$index + ' warehousepricepound'"
                     type="currency" [(ngModel)]="w.PricePerUnit" label="Price Per Unit ({{getUnitsForPurchasePrice()}})" decimalFormat="1.2-4">
          </rms-input>

          <rms-input *ngIf="MultiOrder.BuyingTermID == 2"
                     [suffix]="w.PerPoundCost + '/lb'"
                     (ngModelChange)="updatePerPoundCost(w)"
                     style="flex-basis:15%" [required]="true"
                     [name]="$index + ' warehousediffpound'"
                     type="currency" [(ngModel)]="w.DifferentialPerUnit" label="Diff Per Unit ({{getUnitsForPurchasePrice()}})" decimalFormat="1.2-4">
          </rms-input>

          <!-- Decaf Data -->
          @if(w.Decaf){
          <rms-search-select style="flex-basis:25%" [required]="true"
                             [options]="DecafProducts"
                             labelKey="InventoryTypeName" valueKey="InventoryTypeID"
                             [name]="'decafprod - ' + $index" label="Decaf Product"
                             [(ngModel)]="w.Child.InventoryTypeID">
          </rms-search-select>
          <rms-search-select style="flex-basis:25%" [required]="true"
                             [options]="filteredDecafDestinationWarehousesFor($index)"
                             labelKey="LocationName" valueKey="LocationID"
                             [name]="'Decaf Dest - ' + $index" label="Final Destination Warehouse"
                             [(ngModel)]="w.Child.FinalDestinationWarehouseID">
          </rms-search-select>
          }
          <!-- Monthly containers -->
          @for(s of w.Spread; track $index){
          <rms-number [name]="w.id + '-' + $index + '-' + ' spreadcontract'"
                      [(ngModel)]="s.Containers" [label]="s.label">
          </rms-number>
          }

          @if($index == 0){
          <button class="btn-bg-green" type="button" style="align-self: center" mat-mini-fab title="Add New Destination Warehouse" (click)="addWarehouse()">
            <mat-icon>add</mat-icon>
          </button>
          }
          @else{
          <button type="button" style="align-self: center" mat-mini-fab title="Remove Warehouse" class="btn-bg-red" (click)="onRemoveWarehouse($index)">
            <mat-icon>remove</mat-icon>
          </button>
          }
        </div>
        }
      </form>
    </fieldset>
  </div>

  @if(calcModalData){
  <app-calc-form [calcData]="calcModalData"
                 (onDataChange)="handleTotalsChange($event)"
                 (close)="onCalcClose()">
  </app-calc-form>
  }

  </div>
  <footer class="spread-cancel-bar"><button type="button" mat-flat-button class="btn-bg-red" [disabled]="saving || building" (click)="onReturnToList()">Cancel spread</button></footer>
</section>
